<!--
 * @Author: your name
 * @Date: 2021-01-26 11:59:13
 * @LastEditTime: 2021-01-29 16:58:59
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \aioc-vue\src\components\train\components\certContent.vue
-->

<template>
  <div class="container">
     <div class="auth-bg p24 ">         
         <div class="flex-center ">
            <div class="certImg  mr40"><img :src="certContent.image" /></div>
            <div class="cert-body">
                <div class="mb24  relative">
                    <b class="ft18">{{ certContent.title }}</b>
                    <div class="process-tool">
                        <slot name="process"></slot>
                    </div>
                </div>
                <div class="mb32 intro" v-html=" certContent.intro?certContent.intro:certContent.desc">{{ certContent.intro?certContent.intro:certContent.desc }}</div>
                <div>
                  <slot name="handle"></slot>
                </div>
            </div>
         </div>
          
     </div>
  </div>
</template>

<script>
export default {
    props:['certContent'],
    data(){
        return {
            
        }
    },
    methods:{
      page(index){
          this.$emit('changePage' , index, )
      }
    }
}
</script>

<style scoped lang="scss">
.flex-center{
    display: flex;
    align-items: center;
}
.certImg img{
    width: 362px;
    height: 256px;
}
.cert-body{
    flex: 1;
}
.process-tool{
    position: absolute;
    top: 0px;
    right: 0px;
}
.intro{
    height: 66px;
    line-height: 22px;
    overflow: hidden;
}

</style>



// WEBPACK FOOTER //
// src/components/train/components/certContent.vue